<ft-literature-order-header
  [breadcrumbs]="showBreadcrumb ? breadcrumbItems : null"
></ft-literature-order-header>
<!--ToDo: use commented code after Accounts dependancy is resolved-->
<ng-container *ngIf="profile$ | async as profile">
  <ng-container *ngIf="profile.isLoggedIn">
    <ng-container *ngIf="orderHistoryList">
      <div
        edsGrid
        [edsSpacing]="(isHandheld$ | async) !== true ? 'xxxl' : 'xxl'"
        edsPadding
        [edsPaddingLeft]="(isHandheld$ | async) ? 'sm' : 'none'"
        [edsPaddingRight]="(isHandheld$ | async) ? 'sm' : 'none'"
      >
        <div class="container">
          <div
            id="orderHistoryScrollPosition"
            edsFlexbox
            justifyContent="space-between"
            alignItems="flex-end"
            edsSpacing="md"
          >
            <p edsFlexItem flexGrow="18" edsSpacing="none">
              {{ "literature.lit-order-displaying" | translate }}
              {{ orderHistoryList?.orderHistDetail.length }}
              {{ "literature.lit-listing-items" | translate }}
            </p>
            <eds-dropdown
              *ngIf="
                (isHandheld$ | async) !== true &&
                orderHistoryList?.orderHistDetail.length > 0
              "
              ariaLabel="displayNoRowsDropdown"
              [dropdownId]="'display-rows-drop-down'"
              name="display-rows-drop-down"
              [items]="rowNoItems"
              [preselectedValue]="pageSize"
              label="{{ 'literature.lit-order-display' | translate }}"
              (dropdownChange)="onChange($event)"
              edsFlexItem
              flexGrow="2"
            ></eds-dropdown>
          </div>

          <div
            *ngIf="(isHandheld$ | async) !== true; else contentBlock"
            edsSpacing="md"
          >
            <ag-grid-angular
              stickyHeader
              #orderHistoryListGrid
              [gridOptions]="gridOptions"
              class="ag-theme-frk"
              [rowData]="orderHistoryList?.orderHistDetail"
              [columnDefs]="columnDefs"
              [defaultColDef]="defaultColDef"
              [frameworkComponents]="frameworkComponents"
              [noRowsOverlayComponent]="noRowsOverlayComponent"
              [paginationPageSize]="paginationPageSize"
              [suppressPaginationPanel]="true"
              [suppressHorizontalScroll]="true"
              [suppressCellSelection]="false"
              [suppressDragLeaveHidesColumns]="true"
              [ensureDomOrder]="true"
              [enableCellTextSelection]="true"
            >
            </ag-grid-angular>
          </div>
          <ng-template #contentBlock>
            <div
              *ngIf="orderHistoryList?.orderHistDetail.length > 0"
              edsFlexbox
              flexDirection="row"
              edsSpacing="md"
            >
              <eds-dropdown
                ariaLabel="sortByDropdown"
                [dropdownId]="'sort-by-drop-down'"
                name="sort-by-drop-down"
                [items]="sortByItems"
                label="{{ 'literature.lit-order-display' | translate }}"
                [preselectedValue]="sortByItems[0]"
                edsFlexItem
                flexGrow="1"
                (dropdownChange)="onSorting($event)"
              ></eds-dropdown>
              <eds-dropdown
                ariaLabel="displayNoRowsDropdown"
                [dropdownId]="'display-rows-drop-down'"
                name="display-rows-drop-down"
                [items]="rowNoItems"
                label="{{ 'literature.lit-order-display' | translate }}"
                [preselectedValue]="pageSize"
                (dropdownChange)="onChange($event)"
                edsFlexItem
                flexGrow="2"
              ></eds-dropdown>
            </div>
            <div>
              <ng-container *ngFor="let data of currentPage">
                <eds-panel
                  edsSpacing="md"
                  [hasBorders]="true"
                  [hasPadding]="true"
                >
                  <eds-info-item [info]="getInfo('Item', data)">
                    <eds-link-item
                      edsSpacing="xs"
                      [title]="data.orderNumber"
                      href="#"
                    ></eds-link-item>
                  </eds-info-item>
                  <eds-info-item edsSpacing="xs" [info]="getInfo('Date', data)">
                  </eds-info-item>
                  <eds-info-item
                    edsSpacing="xs"
                    [info]="getInfo('status', data)"
                  >
                  </eds-info-item>
                  <eds-info-item
                    edsSpacing="xs"
                    [info]="getInfo('orderSource', data)"
                  >
                  </eds-info-item>
                </eds-panel>
              </ng-container>
              <eds-panel
                *ngIf="orderHistoryList?.orderHistDetail.length === 0"
                edsSpacing="md"
                [hasBorders]="false"
                [hasPadding]="true"
                theme="grey"
              >
                <div edsSpacing="lg">
                  <eds-image
                    imgSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                    imgFallbackSrc="assets/images/logos/ft-global-logo-vector_74x78.png"
                  >
                  </eds-image>
                </div>
                <p edsSpacing="none">
                  {{ "literature.lit-order-customer-service" | translate }}
                </p>
              </eds-panel>
            </div>
          </ng-template>
          <ng-container *ngIf="orderHistoryList?.orderHistDetail.length > 25">
            <div edsGrid>
              <div edsRow>
                <eds-pagination
                  edsCol
                  *ngIf="numberOfPages > 0"
                  [pages]="numberOfPages"
                  [pageTitle]="pageTitle"
                  (pageChanged)="onPageChanged($event)"
                  prevPageText="{{ 'literature.previous' | translate }}"
                  nextPageText="{{ 'literature.next' | translate }}"
                  ariaLabelGoToPage="{{
                    'literature.ariaLabelGoToPage' | translate
                  }}"
                ></eds-pagination>
                <div
                  edsFlexbox
                  justifyContent="space-between"
                  alignItems="flex-end"
                  edsSpacing="md"
                >
                  <eds-dropdown
                    *ngIf="(isHandheld$ | async) !== true"
                    ariaLabel="displayNoRowsDropdown"
                    [dropdownId]="'display-rows-drop-down'"
                    name="display-rows-drop-down"
                    [items]="rowNoItems"
                    [preselectedValue]="pageSize"
                    label="{{ 'literature.lit-order-display' | translate }}"
                    (dropdownChange)="onChange($event)"
                    edsFlexItem
                    flexGrow="2"
                  ></eds-dropdown>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
